const KLASSISK_HVIT = {
  name: 'Klassisk hvit',
  src: 'Norema/Kitchens/Swatches/Color_S_0500-N.jpg',
}
const BEIGE = {
  name: 'Beige',
  src: 'Norema/Farger/Beige_S_2005-Y20R.jpg',
}
const LYS_GRA = {
  name: 'Lys grå',
  src: 'Norema/Farger/Lys_gr%C3%A5_NCS_S_2500-N.jpg',
}
const MELLOMGRA = {
  name: 'Mellomgrå',
  src: 'Norema/Farger/Mellomgr%C3%A5.jpg',
}
const MORKGRA = {
  name: 'Mørk grå',
  src: 'Norema/Farger/M%C3%B8rk_Gr%C3%A5.jpg',
}
const LINNGRONN = {
  name: 'Lingrønn',
  src: 'Norema/Farger/Lingr%C3%B8nn_NCS_S_2005-G10Y.jpg',
}
const GRONN = {
  name: 'Grønn',
  src: 'Norema/Farger/Gr%C3%B8nn_NCS_S_5005-G50Y.jpg',
}
const MORKBLA = {
  name: 'Mørk blå',
  src: 'Norema/Farger/M%C3%B8rk_bl%C3%A5.jpg',
}
const EIK = {
  name: 'Eik',
  src: 'Norema/Farger/Eik.jpg',
}
const SORT_EIK = {
  name: 'Sort eik',
  src: 'Norema/Farger/Sort_eik.jpg',
}
const LYS_ALM = {
  name: 'Lys alm',
  src: 'Norema/Farger/Lys_alm.png',
}
const TROFFELGRA_EIK = {
  name: 'Trøffelgrå eik',
  src: 'Norema/Farger/Tr%C3%B8ffelgr%C3%A5_eik.png',
}
const BRUN_EIK = {
  name: 'Brun eik',
  src: 'Norema/Farger/Sort_eik.jpg',
}
const PEACH_TONITON = {
  name: 'Toniton peach',
  src: 'Marbodal/Price%20Configurator/Colors/toniton-peach.webp',
}
const CREAME_TONITON = {
  name: 'Toniton creme',
  src: 'Marbodal/Price%20Configurator/Colors/toniton-creme.webp',
}
const BLUE_TONITON = {
  name: 'Toniton blue',
  src: 'Marbodal/Price%20Configurator/Colors/toniton-blue.webp',
}
const GREEN_TONITON = {
  name: 'Toniton green',
  src: 'Marbodal/Price%20Configurator/Colors/toniton-green.webp',
}
const GREY_TONITON = {
  name: 'Toniton grey',
  src: 'Marbodal/Price%20Configurator/Colors/toniton-grey.webp',
}
const YELLOW_TONITON = {
  name: 'Toniton yellow',
  src: 'Marbodal/Price%20Configurator/Colors/toniton-yellow.webp',
}

export const COLORS = {
  pluss: [KLASSISK_HVIT, MORKGRA],
  fager: [
    KLASSISK_HVIT,
    BEIGE,
    LYS_GRA,
    MELLOMGRA,
    MORKGRA,
    LINNGRONN,
    GRONN,
    MORKBLA,
  ],
  trapes: [EIK, SORT_EIK],
  areal: [
    KLASSISK_HVIT,
    BEIGE,
    LYS_GRA,
    MELLOMGRA,
    MORKGRA,
    LINNGRONN,
    GRONN,
    MORKBLA,
  ],
  system: [KLASSISK_HVIT],
  // systemSort: [SORT_EIK],
  parallel: [KLASSISK_HVIT, MELLOMGRA],
  kvadrat: [BRUN_EIK, SORT_EIK],
  kube: [SORT_EIK, EIK],
  designAkse: [BRUN_EIK],
  aspektKlassiskHvit: [KLASSISK_HVIT],
  hisoyGrep: [KLASSISK_HVIT, LYS_GRA, MELLOMGRA],
  notteroy: [
    KLASSISK_HVIT,
    BRUN_EIK,
    LYS_ALM,
    MELLOMGRA,
    SORT_EIK,
    TROFFELGRA_EIK,
  ],
  format: [
    KLASSISK_HVIT,
    BEIGE,
    LYS_GRA,
    MELLOMGRA,
    MORKGRA,
    LINNGRONN,
    GRONN,
    MORKBLA,
  ],
  toniton: [
    PEACH_TONITON,
    CREAME_TONITON,
    BLUE_TONITON,
    GREEN_TONITON,
    GREY_TONITON,
    YELLOW_TONITON,
  ],
  stjernoya: [BEIGE, GRONN, LYS_GRA, MELLOMGRA],
  tromoy: [KLASSISK_HVIT, LYS_GRA, MELLOMGRA],
  haoya: [KLASSISK_HVIT, LYS_GRA, MELLOMGRA],
  asmaloyKlassiskHvit: [KLASSISK_HVIT],
}

const HOME_PATH = 'Norema/Kitchens/Home%20Collection/Milj%C3%B8bilder'
const BASIC_PATH =
  'Norema/Kitchens/Basic%20Collection/Milj%C3%B8bilder%20Basic%20Collection/'

export const RANGES = {
  pluss: `${HOME_PATH}/2023%20bilder%20Home/Norema_Pluss_Kvadrat_Vit__Home_v5.0001.jpg`,
  fager: `${HOME_PATH}/2023%20bilder%20Home/Norema_Fager_Home_Fager_Home_v8.0004.jpg`,
  trapes: `${HOME_PATH}/2023%20bilder%20Home/Norema_Trapes_Home_Trapes_Home_v9.0001.jpg`,
  areal: `${HOME_PATH}/2023%20bilder%20Home/Norema_Areal_Home_v7.0001.jpg`,
  system: `${HOME_PATH}/2023%20bilder%20Home/Norema_System_Home_v2.0003.jpg`,
  // systemSort: `${HOME_PATH}/Norema_System_sort.jpg`,
  parallel: `${HOME_PATH}/2023%20bilder%20Home/Norema_Parallell_Home_Parallell_Home_v4.0001.jpg`,
  kvadrat: `${HOME_PATH}/2023%20bilder%20Home/Norema_Kvadrat_Fine_%C3%BCr_Sort_Home_v5.0001.jpg`,
  kube: `${HOME_PATH}/2023%20bilder%20Home/Norema_Kube_Home_Kube_Home_v3.0001.jpg`,
  designAkse: `${HOME_PATH}/2023%20bilder%20Home/Akse_Home_norema.jpg`,
  aspektKlassiskHvit: `${HOME_PATH}/Norema_Aspekt.jpg`,
  hisoyGrep: `${BASIC_PATH}/Nye%20bilder%202023/Norema_His%C3%B8y_grep_Basic_v4.0001.jpg`,
  notteroy: `${BASIC_PATH}/Nye%20bilder%202023/Norema_N%C3%B8tter%C3%B8y_lys_alm_Basic_v3.0001.jpg`,
  stjernoya: `${BASIC_PATH}/Nye%20bilder%202023/Norema_Stjern%C3%B8ya_Basic_v4.0001.jpg`,
  tromoy: `${BASIC_PATH}/Nye%20bilder%202023/Norema_Trom%C3%B8y_Basic_v3.0001.jpg`,
  haoya: `${BASIC_PATH}/Nye%20bilder%202023/Norema_H%C3%A5%C3%B8ya_Basic_v5.0001.jpg`,
  toniton: `${HOME_PATH}/Toniton_x_Norema_kj%C3%B8kken.jpg`,
  format: `${HOME_PATH}/2023%20bilder%20Home/Noreman_Format_Home_Format_Home_v15.0001.jpg`,
  asmaloyKlassiskHvit: `${BASIC_PATH}/Nye%20bilder%202023/Norema_Asmal%C3%B8y_Basic.jpg`,
}
export const UNITS = {
  small: 'Marbodal/Price%20Configurator/Units/units-small.png',
  medium: 'Marbodal/Price%20Configurator/Units/units-medium.png',
  large: 'Marbodal/Price%20Configurator/Units/units-large.png',
}

export const WORKTOPS = {
  granite: 'Marbodal/Price%20Configurator/Worktops/granit.jpg',
  wood: 'Marbodal/Price%20Configurator/Worktops/ek.jpg',
  laminate: 'Marbodal/Price%20Configurator/Worktops/laminat.jpg',
  stainless: 'Marbodal/Price%20Configurator/Worktops/rostfri.jpg',
}
